module.exports = __webpack_public_path__ + "media/images/fiable-5fd4278c56134f22207ac6bf2ece8a2d.svg";